import api from "src/apis/api"

export async function fetchNotifications() {
  const { data } = await api.get("/api/v1/notifications")
  return data
}

export async function markNotificationRead(id) {
  const { data } = await api.patch(`/api/v1/notifications/${id}/read`)
  return data.notification
}

export async function markAllRead() {
  const { data } = await api.post("/api/v1/notifications/mark_all_read")
  return data
}
